import axios from 'axios';
import ApiAuthenticationService from "../services/ApiAuthenticationService";

//Cette fonction permet d'intercepter toutes les requetes AJAX et d'ajouter le "Bearer" si besoin
export function InitSecureRequestInterceptor(){
    axios.interceptors.request.use(function (config) {
        if(config.url.indexOf(process.env.VUE_APP_API_SECURE_URI) === 0){
            //On ajoute le bearer si il en exite un
            const token = ApiAuthenticationService.getAccessToken();
            if(token){
                config.headers.Authorization =  "Bearer "+token;
                return config;
            }
        }

        return config;
    });
}
